// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import OfferTemplate from 'components/offer/OfferTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CartActions } from 'store/actionCreators';

type Props = {
  logged: boolean,
  order: any,
  cart: any,
};

class OfferTemplateContainer extends Component<Props> {
  state = {
    initLoading: true,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    const { history } = this.props;
    try {
      let cart = {
        done: true,
        meta: {
          taxFile: null,
        },
        paidAt: null,
        status: null,
        synced: true,
        address: {},
        items: [],
        total: {},
      };
      let items = [];
      this.props.cart.items
        .filter(item => item.checked === true)
        .map(item => {
          return items.push({
            ...item,
            price: {
              sale: {
                raw: item.product_price.price,
              },
              original: {
                raw: item.product_price.original_price,
              },
            },
            total: {
              price: {
                sale: {
                  raw: Math.round(item.product_price.price * item.quantity),
                },
                original: {
                  raw: Math.round(item.product_price.original_price * item.quantity),
                },
              },
              taxed: {
                raw: Math.round(item.product_price.price * item.quantity * 0.1),
              },
              discounted: {
                raw: Math.round(
                  (item.product_price.original_price - item.product_price.price) * item.quantity,
                ),
              },
            },
          });
        });
      cart.items = items;
      cart.total = {
        paid: {
          raw: 0,
        },
        price: {
          sale: {
            raw: 0,
          },
          original: {
            raw: 0,
          },
        },
        taxed: {
          raw: 0,
        },
        amount: {
          raw: 0,
        },
        shipping: {
          fee: {
            sale: {
              raw: 0,
            },
          },
        },
        discounted: {
          raw: 0,
        },
      };
      cart.total.price.sale.raw = items.reduce((acc, cur) => acc + cur.total.price.sale.raw, 0);
      cart.total.price.original.raw = items.reduce(
        (acc, cur) => acc + cur.total.price.original.raw,
        0,
      );
      cart.total.discounted.raw = items.reduce((acc, cur) => acc + cur.total.discounted.raw, 0);
      cart.total.shipping.fee.sale.raw = cart.total.price.sale.raw >= 100000 ? 0 : 3500;
      cart.total.taxed.raw = Math.round(
        items.reduce((acc, cur) => acc + cur.total.taxed.raw, 0) +
          cart.total.shipping.fee.sale.raw * 0.1,
      );
      cart.total.amount.raw =
        cart.total.price.sale.raw + cart.total.shipping.fee.sale.raw + cart.total.taxed.raw;

      if (this.props.logged) {
        await CartActions.getCart(cart);
      } else {
        await CartActions.getAsNonRegisteredCart(cart);
      }
      this.setState({ initLoading: false });
      setTimeout(() => {
        window.print();
        history.push('/cart');
      }, 1000);
    } catch (e) {
      console.log(e);
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    if (this.state.initLoading) return <Circles color="blue" size="medium" text="Loading..." />;

    return <OfferTemplate cart={this.props.cart} />;
  }
}

export default connect(
  ({ cart, user, pender }: State) => ({
    cart,
    user,
    logged: !!user.user,
    loading: pender.pending['cart/GET_CART'],
    loading1: pender.pending['cart/GET_AS_NON_REGISTERED_CART'],
  }),
  () => ({}),
)(withRouter(OfferTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/offer/OfferTemplateContainer.js